export default __webpack_public_path__ + "static/media/Web_instructions-01.20cffc30.png";